export enum SessionStatus {
  STATUS_TERMINATED = 8,
}
